const Distributors = {
    VANDELAY_COMPANY_ID: '60d613ea-c3db-4265-9a46-442553c8619a',
    MY_MACHINE_COMPANY_ID: 'bb214e6d-7c4f-4769-862c-ebe342361d62',
    CONNECTED_CREATIVE_COMPANY_ID: 'b62a8265-80ac-4a95-a8a8-83871d551f90',

    CHURN_IMMEDIATELY: 'CHURN-IMMEDIATELY',
    CHURN_SET: 'CHURN-SET',
    CHURN_UNSET: 'CHURN-UNSET',
};

export const isTestTenant = (tenant_id) => {
    return [Distributors.VANDELAY_COMPANY_ID, Distributors.MY_MACHINE_COMPANY_ID, Distributors.CONNECTED_CREATIVE_COMPANY_ID].includes(tenant_id);
};

export default Distributors;
